module.exports = __webpack_public_path__ + "r-v3/img/ml_21_00_over.341f9e5b.jpg";